export enum ConsentType {
    Info = 'info',
    Checkbox = 'checkbox'
}

export enum ConsentCategoryType {
    PurposeOfTheForm = 'purpose_of_the_form',
    // ThirdPartyIntegrations = 'third_party_integrations',
    DataRetention = 'data_retention',
    RespondersRights = 'responder_rights'
}

export type ResponseRetentionType = 'days' | 'date' | 'forever';
